import * as Yup from 'yup';
import moment from 'moment';

import { VALIDATIONS_ERROR } from '~constants/validationsError';

import { ReportsDownloadSectionWrapperFormValues } from './types';

export const FIELDS_NAME = {
  TYPE: 'type',
  DATE_FROM: 'dateFrom',
  DATE_TO: 'dateTo',
} as const;

export const initialValues: ReportsDownloadSectionWrapperFormValues = {
  [FIELDS_NAME.TYPE]: null,
  [FIELDS_NAME.DATE_FROM]: null,
  [FIELDS_NAME.DATE_TO]: null,
} as const;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getValidationSchema = (withSelectorType: boolean) =>
  Yup.object().shape({
    [FIELDS_NAME.TYPE]: withSelectorType
      ? Yup.string().nullable().required(VALIDATIONS_ERROR.REQUIRED)
      : Yup.string().nullable().notRequired(),
    [FIELDS_NAME.DATE_FROM]: Yup.date()
      .nullable()
      .typeError(VALIDATIONS_ERROR.INVALID_DATE)
      .required(VALIDATIONS_ERROR.REQUIRED),
    [FIELDS_NAME.DATE_TO]: Yup.date()
      .nullable()
      .typeError(VALIDATIONS_ERROR.INVALID_DATE)
      .required(VALIDATIONS_ERROR.REQUIRED),
  });

export const getMinDatePicker = (): Date =>
  moment().subtract(30, 'days').startOf('day').toDate();
